import * as kinds from '@nostr/tools/kinds'
import { NostrEvent } from '@nostr/tools/wasm'

import { eventMentionsPubKeyInContent, findFirstDirectReplyToPubkey } from './event'
import { tagNameEquals } from './tag'

export function notificationFilter(
  event: NostrEvent,
  {
    pubkey,
    mutePubkeySet
  }: {
    pubkey?: string | null
    mutePubkeySet: Set<string>
  }
): boolean {
  if (mutePubkeySet.has(event.pubkey)) {
    return false
  }

  if (pubkey && event.kind === kinds.Reaction) {
    const targetPubkey = event.tags.findLast(tagNameEquals('p'))?.[1]
    if (targetPubkey !== pubkey) return false
  }

  return true
}

export const replyKinds = [
  kinds.ShortTextNote,
  kinds.Comment,
  kinds.VoiceComment,
  kinds.PollResponse
]

export const reactionKinds = [kinds.Repost, kinds.Reaction]

// check if an event is a mention (explicit mention or direct reply)
export async function isMention(event: NostrEvent, pubkey: string): Promise<boolean> {
  // check explicit mentions in content
  if (eventMentionsPubKeyInContent(event, pubkey)) return true

  // check if this is a direct reply to user's note
  return !!(await findFirstDirectReplyToPubkey(event, pubkey))
}
